import {
  CellInfo,
  RowInfo,
  ColumnProjection,
  GetColumnsProps,
} from './ticketListConfigurations.types';
import {
  voidedAccessor,
  ticketNumberAccessor,
  ticketedTimestampAccessor,
  truckAliasAccessor,
  driverNameAccessor,
  customerAccessor,
  orderNumberAccessor,
  addressAccessor,
  loadingPlantAccessor,
} from './ticketColumnAccessors';

export default function getColumns(props: GetColumnsProps): ColumnProjection[] {
  const { cellStyle, headerStyle } = props;

  const projectAccessor = (row: RowInfo) =>
    voidedAccessor(row?.voided, row?.order?.projectName ?? '');

  const orderNumberCell = (cellInfo: CellInfo) =>
    cellInfo && cellInfo.original ? props.orderDetails!(cellInfo.original) : '';
  const lastTickets = [
    {
      Header: 'Ticket #',
      id: 'ticketNumber',
      accessor: ticketNumberAccessor,
      style: cellStyle,
      width: 110,
      headerStyle,
    },
    {
      Header: 'Date',
      id: 'ticketedTimestamp',
      accessor: ticketedTimestampAccessor,
      style: cellStyle,
      width: 120,
      headerStyle,
    },
    {
      Header: 'Truck',
      id: 'truckAlias',
      accessor: truckAliasAccessor,
      className: 'vehicle-cell',
      headerClassName: 'vehicle-header',
      width: 155,
      style: cellStyle,
      headerStyle,
    },
    {
      Header: 'Current/ Last Driver',
      id: 'currentDriver',
      accessor: driverNameAccessor,
      className: 'ticket-cell',
      headerClassName: 'ticket-header',
      style: cellStyle,
      width: 300,
      headerStyle,
    },
    {
      Header: 'Order #',
      id: 'orderNumber',
      accessor: orderNumberAccessor,
      Cell: orderNumberCell,
      className: 'order-cell',
      headerClassName: 'order-header',
      style: cellStyle,
      width: 80,
      headerStyle,
      sortMethod: (
        a: ReturnType<typeof orderNumberAccessor>,
        b: ReturnType<typeof orderNumberAccessor>,
      ) => {
        let aValue: number = 0;
        let bValue: number = 0;
        if (typeof a === 'string') {
          aValue = parseInt(a, 10);
        } else if (typeof a === 'object' && a?.props?.children) {
          aValue = a.props.children;
        }

        if (typeof b === 'string') {
          bValue = parseInt(b, 10);
        } else if (typeof b === 'object' && b?.props?.children) {
          bValue = b.props.children;
        }

        aValue = Number.isNaN(aValue) ? 0 : aValue;
        bValue = Number.isNaN(bValue) ? 0 : bValue;
        return aValue - bValue;
      },
    },
    {
      Header: 'Customer',
      id: 'customerName',
      accessor: customerAccessor,
      className: 'name-cell',
      headerClassName: 'name-header',
      style: cellStyle,
      width: 200,
      headerStyle,
    },
    {
      Header: 'Project',
      id: 'ProjectName',
      accessor: projectAccessor,
      className: 'name-cell',
      headerClassName: 'name-header',
      style: cellStyle,
      width: 200,
      headerStyle,
    },
    {
      Header: 'Delivery Address',
      id: 'address',
      accessor: addressAccessor,
      className: 'address-cell',
      headerClassName: 'address-header',
      width: 350,
      style: cellStyle,
      headerStyle,
    },
    {
      Header: 'Loading Plant',
      id: 'loadingPlant',
      accessor: loadingPlantAccessor,
      className: 'ticket-cell',
      headerClassName: 'ticket-header',
      style: cellStyle,
      width: 964,
      headerStyle,
    },
  ];

  return lastTickets;
}
